import React, { useContext, useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { AuthContext } from "../../../Context/AuthContext/AuthContext";
import { getIngresosPromedio } from "../../../API/Inventarios/BodegaMateriales/BodegaMaterialesRequests";
import { Button } from "primereact/button";
import AgGrid from "../../../Components/Tables/AgGrid/AgGrid";
import Loader from "../../../Components/Loader/Loader";

const ModalIngresosPromedio = ({
  dialogPromedio,
  hideDialogPromedio,
  IdProducto,
  IdReferencia,
  CodigoProducto = null,
}) => {
  const { userAuth } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const getInfo = async () => {
    setLoading(true);
    const info = {
      IdReferencia,
      IdProducto,
      CodigoProducto,
    };
    const result = await getIngresosPromedio(info);
    console.log(">>>>>>>>>>>>.", result);
    setData(result);
    setLoading(false);
  };

  const columns = [
    {
      field: "IdIngreso",
      header: "IdIngresoEnc",
      headerEn: "IdIngresoEnc",
      className: "Xsmall",
      hidden: userAuth.IdRol === 1,
      //   onCellDoubleClicked: ({ data }) => {
      //     if (data.IdIngreso) {
      //       openIngreso(data);
      //     }
      //   },
    },
    {
      field: "NumeroIngreso",
      header: "Numero Ingreso",
      headerEn: "Numero Ingreso",
      className: "small",
      Format: "Center",
      Sumary: "count",
      //   onCellDoubleClicked: ({ data }) => {
      //     if (data.IdIngreso) {
      //       openIngreso(data);
      //     }
      //   },
    },
    {
      field: "FechaIngreso",
      header: "FechaIngreso",
      headerEn: "FechaIngreso",
      className: "small",
      Format: "Date",
      sort: "asc",
    },

    {
      field: "CodigoProducto",
      header: "Codigo Producto",
      headerEn: "Codigo Producto",
      className: "small",
      Format: "Center",
    },
    {
      field: "NombreProducto",
      header: "NombreProducto",
      headerEn: "NombreProducto",
      className: "",
    },
    {
      field: "Ingreso",
      header: "Ingreso",
      headerEn: "Ingreso",
      className: "Xsmall",
      Format: "Currency",
      Sumary: "sum",
    },
    {
      field: "Inventario",
      header: "Inventario",
      headerEn: "Inventario",
      className: "small",
      Format: "Currency",
      Sumary: "sum",
    },
    {
      field: "TipoIngreso",
      header: "Tipo Ingreso",
      headerEn: "Tipo Ingreso",
      className: "small",
      Format: "Center",
    },
    {
      field: "Antiguedad",
      header: "Antiguedad",
      headerEn: "Antiguedad",
      className: "small",
    },
    {
      field: "EstadoAntiguedad",
      header: "Estado Antiguedad",
      headerEn: "Estado Antiguedad",
      className: "small",
    },
    {
      field: "PrecioL",
      header: "Precio L",
      headerEn: "Price L",
      className: "Xsmall",
      Format: "Currency",
      Frozen: true,
      alignFrozen: "right",
    },
    {
      field: "MontoL",
      header: "Monto L",
      headerEn: "Amount L",
      className: "small",
      Format: "Currency",
      Sumary: "sum",
      Frozen: true,
      alignFrozen: "right",
    },
    {
      field: "PrecioD",
      header: "Precio $",
      headerEn: "Price $",
      className: "small",
      Format: "Currency",
      Frozen: true,
      alignFrozen: "right",
    },

    {
      field: "MontoD",
      header: "Monto $",
      headerEn: "Amount 4",
      className: "small",
      Format: "Currency",
      Sumary: "sum",
      Frozen: true,
      alignFrozen: "right",
    },
  ];

  const table = {
    Columns: columns,
    Data: data,
  };

  useEffect(() => {
    if (dialogPromedio) {
      getInfo();
    }
  }, [dialogPromedio]);

  return (
    <Dialog
      visible={dialogPromedio}
      onHide={hideDialogPromedio}
      style={{ width: "80vw", height: "80vh" }}
      header={
        <div className="d-flex gap" style={{ alignItems: "center" }}>
          <h3>Ingresos Bodega Hilaza</h3>
          <Button
            icon="pi pi-refresh"
            onClick={() => getInfo()}
            loading={loading}
          />
        </div>
      }
    >
      <Loader loading={loading} querySelector={"#IngresosPromedio"} />
      <div style={{ width: "100%", height: "70vh" }} id="IngresosPromedio">
        <AgGrid table={table} />
      </div>
    </Dialog>
  );
};

export default ModalIngresosPromedio;
